
import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import {SignLanguage, TipsAndUpdates, GroupAdd} from '@mui/icons-material';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { StepIconProps } from '@mui/material/StepIcon';
import { Content, Footer, Header } from '../Component';
import { Box, Container, Typography } from '@mui/material';
import { useApp } from '../Contexts/AppProvider';
import Home from './Home';
import Registration from './Registration';
import Voucher from './Voucher';
import { useTheme } from '../Contexts/ThemeProvider';

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        `linear-gradient( 359deg, ${theme?.palette?.primary?.dark} 0%, ${theme?.palette?.primary?.light} 50%, ${theme?.palette?.primary?.contrastText} 100%)`,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        `linear-gradient( 359deg, ${theme?.palette?.primary?.dark} 0%, ${theme?.palette?.primary?.dark} 50%, ${theme?.palette?.primary?.contrastText} 100%)`,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor:
      theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
    borderRadius: 1,
  },
}));

interface IColorLibStep {
  completed?: boolean;
  active?: boolean
}

const ColorlibStepIconRoot = styled('div')<{ownerState: IColorLibStep}>(({ ownerState }) => {
  const {theme} = useTheme();
  return {
    backgroundColor: '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    ...(ownerState.active && {
      backgroundImage:
        `linear-gradient( 45deg, ${theme?.palette?.primary?.dark} 0%, ${theme?.palette?.primary?.light} 50%, ${theme?.palette?.primary?.contrastText} 100%)`,
      boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
    }),
    ...(ownerState.completed && {
      backgroundImage:
      `linear-gradient( 45deg, ${theme?.palette?.primary?.dark} 0%, ${theme?.palette?.primary?.light} 50%, ${theme?.palette?.primary?.contrastText} 100%)`,
    }),
  }
});

function ColorlibStepIcon(props: StepIconProps) {
  const { active, completed, className } = props;

  const icons: { [index: string]: React.ReactElement } = {
    1: <TipsAndUpdates />,
    2: <GroupAdd />,
    3: <SignLanguage />,
  };

  return (
    <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
      {icons[String(props.icon)]}
    </ColorlibStepIconRoot>
  );
}

export default function CustomizedSteppers() {
  const {activeStep, config} = useApp();

  const page: { [index: string]: React.ReactElement } = {
    0: <Home />,
    1: <Registration />,
    2: <Voucher />,
  }

  return activeStep !== undefined ? (
    <Container>
      <Header />
      <Box>
        <Box sx={{ p: 3 }}>
          <Stack sx={{ width: '100%' }}>
            <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
              {config?.steps.map(({label}) => (
                <Step key={label}>
                  <StepLabel StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
          </Stack>
        </Box>
          
        <Content>
          {activeStep === 1 && <Typography variant='h4'>{config?.steps[activeStep].label}</Typography>}
          <span dangerouslySetInnerHTML={{__html: config?.steps[activeStep]?.description as string}} />
          {page[String(activeStep)]}
        </Content>
      </Box>
      <Footer />
    </Container>
  ) : <></>;
}
